import { Numeric } from './numeric';
export var Fractions;
(function (Fractions) {
    function sum(...values) {
        if (values.length == 0) {
            throw new Error('Empty array');
        }
        if (values.length == 1) {
            return values[0];
        }
        const denominator = Numeric.gcd(...values.map(([, denominator]) => denominator));
        const numerator = values.map(([n, d]) => n * (denominator / d)).reduce((a, b) => a + b);
        return [numerator, denominator];
    }
    Fractions.sum = sum;
    function isEqual(a, b) {
        const [[na, da], [nb, db]] = normalize([a, b]);
        return na == nb && da == db;
    }
    Fractions.isEqual = isEqual;
    function reduce(numerator, denominator) {
        const d = Numeric.gcd(numerator, denominator);
        return [numerator / d, denominator / d];
    }
    Fractions.reduce = reduce;
    function normalize(values) {
        if (values.length == 0) {
            throw new Error('Empty array');
        }
        if (values.length == 1) {
            return values;
        }
        const reduced = values.map(([n, d]) => reduce(n, d));
        const denominator = commonDenominator(...reduced);
        return reduced.map(([n, d]) => [n * (denominator / d), denominator]);
    }
    Fractions.normalize = normalize;
    function commonDenominator(...values) {
        return Numeric.lcm(...values.map(([, denominator]) => denominator));
    }
    Fractions.commonDenominator = commonDenominator;
})(Fractions || (Fractions = {}));
export function normalizeToCommonDenominator(values) {
    const commonDenominator = Numeric.gcd(...values.map(([, denominator]) => denominator));
    return values.map(([numerator, denominator]) => [numerator * (commonDenominator / denominator), commonDenominator]);
}
export function reduceFrac(numerator, denominator) {
    const d = Numeric.gcd(numerator, denominator);
    return [numerator / d, denominator / d];
}
//# sourceMappingURL=fractions.js.map